<template>
  <v-container>
    <v-row>
      <v-col :cols="12" class="text-center">
        <h1>{{ $t('content.jobs2share.label') }}</h1>
      </v-col>
    </v-row>
    <v-row id="section-1">
      <v-col :cols="12">
        <h2>{{ $t('content.sponsorship.label') }}</h2>
        <p v-html="$t('content.sponsorship.text')"></p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3>{{ $t('content.partner.ourMembers') }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card flat>
          <v-card-text class="d-flex flex-wrap justify-center">
            <div v-for="(logo, index) in companyLogos" :key="index">
              <img
                class="logo"
                :src="`${logoPathMembers}${logo.img}`"
                :alt="logo.alt"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row id="section-2">
      <v-col>
        <h2>{{ $t('content.partner.label') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="mb-3" flat>
          <v-card-text class="d-flex flex-wrap justify-center">
            <div v-for="(logo, index) in partnerLogos" :key="index">
              <img
                class="logo"
                :src="`${logoPathPartners}${logo.img}`"
                :alt="logo.alt"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="!maintenanceActive">
      <v-row id="section-3">
        <v-col>
          <h2>{{ $t('content.media.label') }}</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="mb-3" flat>
            <v-card-title>
              <h3>{{ $t('content.media.mediaReports') }}</h3>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  v-for="mediaReport in mediaReports"
                  :key="mediaReport.id"
                  :href="mediaReport.file ? mediaReport.file : mediaReport.link"
                  target="_blank"
                >
                  <v-list-item-avatar>
                    <v-icon>{{  mediaReport.file ? 'insert_drive_file' : 'link' }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ mediaReport.title }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="12" :xl="6">
          <v-card flat>
            <v-card-title>
              <h3>{{ $t('content.media.mediaKit') }}</h3>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  v-for="mediaKit in mediaKits"
                  :key="mediaKit.id"
                  :href="mediaKit.file ? mediaKit.file : mediaKit.link"
                  target="_blank"
                >
                  <v-list-item-avatar>
                    <v-icon>{{  mediaKit.file ? 'insert_drive_file' : 'link' }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ mediaKit.title }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col :cols="12" :md="6" :xl="3">
          <v-card flat>
            <v-card-title>
              <h3>{{ $t('content.media.pressReleaseDe') }}</h3>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  v-for="pressRelease in pressReleases.de"
                  :key="pressRelease.id"
                  :href="pressRelease.file ? pressRelease.file : pressRelease.link"
                  target="_blank"
                >
                  <v-list-item-avatar>
                    <v-icon>{{  pressRelease.file ? 'insert_drive_file' : 'link' }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ pressRelease.title }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col s12 :md="6" :xl="3">
          <v-card flat>
            <v-card-title>
              <h3>{{ $t('content.media.pressReleaseIt') }}</h3>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  v-for="pressRelease in pressReleases.it"
                  :key="pressRelease.id"
                  :href="pressRelease.file ? pressRelease.file : pressRelease.link"
                  target="_blank"
                >
                  <v-list-item-avatar>
                    <v-icon>{{  pressRelease.file ? 'insert_drive_file' : 'link' }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ pressRelease.title }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapGeneralState, mapActions: mapGeneralActions } = createNamespacedHelpers('general');
const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'About',
  data() {
    return {
      logoPathPartners: '/static/logos/partner/',
      logoPathMembers: '/static/logos/member/',
    };
  },
  mounted() {
    this.fetchMedia();
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  created() {
    if (!this.maintenanceActive) {
      this.fetchMedia();
    }
  },
  computed: {
    ...mapUserState([
      'maintenanceActive',
      'language',
    ]),
    ...mapGeneralState([
      'pressReleases',
      'mediaReports',
      'mediaKits',
    ]),
    companyLogos() {
      const logos = [
        {
          img: 'logo-albergo-losone.jpg',
          alt: 'Logo Albergo Losone',
          url: 'https://www.albergolosone.ch/',
        },
        {
          img: 'logo-badrutts-palace.jpg',
          alt: 'Logo Badrutt\'s Palace',
          url: 'https://www.badruttspalace.com/de',
        },
        {
          img: 'logo-albergo-carcani.jpg',
          alt: 'Logo Albergo Carcani',
          url: 'https://carcani.ch/de',
        },
        {
          img: 'logo-casa-berno.jpg',
          alt: 'Logo Hotel Casa Berno',
          url: 'https://www.casaberno.ch/',
        },
        {
          img: 'logo-castello-del-sole.jpg',
          alt: 'Logo Castello del Sole',
          url: 'https://www.castellodelsole.com/de',
        },
        {
          img: 'logo-eden-roc.jpg',
          alt: 'Logo Hotel Eden Roc',
          url: 'https://edenroc.ch/de',
        },
        {
          img: 'logo-belvedere-scuol.jpg',
          alt: 'Logo Bélvedère Hotel Gruppe',
          url: 'https://www.belvedere-scuol.ch/',
        },
        {
          img: 'logo-carlton.jpg',
          alt: 'Logo Carlton Hotel',
          url: 'https://carlton-stmoritz.ch/de',
        },
        {
          img: 'logo-chesa-rosatsch.jpg',
          alt: 'Logo Chesa Rosatsch',
          url: 'http://rosatsch.ch/',
        },
        {
          img: 'logo-delfino.jpg',
          alt: 'Logo Hotel Delfino',
          url: 'http://www.hoteldelfinolugano.ch/de/',
        },
        {
          img: 'logo-grischa.jpg',
          alt: 'Logo Hotel Grischa',
          url: 'https://www.hotelgrischa.ch/de/',
        },
        {
          img: 'logo-guarda-val.jpg',
          alt: 'Logo Hotel Guarda Val',
          url: 'http://www.guardaval.ch/',
          show: false,
        },
        {
          img: 'logo-la-rocca.jpg',
          alt: 'Logo Boutique-Hotel La Rocca',
          url: 'https://www.la-rocca.ch/de',
        },
        {
          img: 'logo-laax.jpg',
          alt: 'Logo Laax',
          url: 'http://weissearena.com/de/',
        },
        {
          img: 'logo-rocksresort.jpg',
          alt: 'Logo Rocksresort',
          url: 'http://www.rocksresort.com/de/hotel-flims-laax-falera/',
        },
        {
          img: 'logo-schweizerhof.jpg',
          alt: 'Logo Schweizerhof Lenzerheide',
          url: 'https://www.schweizerhof-lenzerheide.ch/de/',
        },
        {
          img: 'logo-signinahotel.jpg',
          alt: 'Logo Signinahotel',
          url: 'https://www.signinahotel.com/',
        },
        {
          img: 'logo-tschuggen.jpg',
          alt: 'Logo Tschuggen Grand Hotel',
          url: 'https://tschuggen.ch/de',
        },
        {
          img: 'logo-valsana.jpg',
          alt: 'Logo Valsana Hotel & Appartements',
          url: 'https://valsana.ch/de',
        },
        {
          img: 'logo-villa-castagnola.jpg',
          alt: 'Logo Villa Castagnola',
          url: 'https://www.villacastagnola.com/de',
        },
        {
          img: 'logo-villa-orselina.jpg',
          alt: 'Logo Villa Orselina',
          url: 'http://www.villaorselina.ch/de',
        },
        {
          img: 'logo-viznauerhof.jpg',
          alt: 'Logo Vitznauerhof',
          url: 'http://vitznauerhof.ch/',
        },
        {
          img: 'logo-waldhaus-flims.jpg',
          alt: 'Logo Flims Waldhaus',
          url: 'http://waldhaus-flims.ch/de',
        },
        {
          img: 'logo-see-park-hotel-feldbach.jpg',
          alt: 'Logo See & Park Hotel Feldbach',
          url: 'https://hotel-feldbach.ch/',
        },
        {
          img: 'logo-hotelleriesuisse-graubuenden.jpg',
          alt: 'Logo Hotelleriesuisse Graubünden',
          url: 'http://hsgr.ch/de/pub/graubuenden.htm',
        },
        {
          img: 'logo-hotelleriesuisse-ticino.jpg',
          alt: 'Logo Hotelleriesuisse Ticino',
          url: 'http://www.hotelleriesuisse-ticino.ch/de/pub/tessin.htm',
        },
        {
          img: 'logo-fhgr.jpg',
          alt: 'Logo Fachhochschule Graubünden',
          url: 'http://www.fhgr.ch/',
        },
        {
          img: 'logo-gastro-graubuenden.jpg',
          alt: 'Logo Gastro Graubünden',
          url: 'https://www.gastrograubuenden.ch/',
        },
      ];
      return logos.filter((logo) => logo.show !== false);
    },
    partnerLogos() {
      const logos = [
        {
          img: 'logo-seco.jpg',
          alt: 'Staatssekretariat für Wirtschaft SECO',
          url: '',
        },
        {
          img: 'logo-cantone-ticino.jpg',
          alt: 'Cantone Ticino',
          url: '',
        },
        {
          img: 'logo-kanton-graubuenden.jpg',
          alt: 'Kanton Graubünden',
          url: '',
        },
        {
          img: 'logo-hotel-gastro-formation.jpg',
          alt: 'Hotel & Gastro Formation',
          url: '',
        },
      ];
      return logos;
    },
  },
  methods: {
    ...mapGeneralActions([
      'fetchMedia',
    ]),
    scrollToSection(section) {
      if (section !== '') {
        this.$vuetify.goTo(section);
      }
    },
    scrollToHash() {
      this.scrollToSection(this.$route.hash);
    },
  },
  watch: {
    $route: 'scrollToHash',
    language: 'fetchMedia',
  },
};
</script>

<style lang="scss" scoped>
  .logo {
    width: 200px;
    height: auto;
    margin: 20px;
  }
</style>
